import router from '../router/index'
import store from "../store/store";

import { axios, BaseApiUrl ,BaseUrl} from './axios_config';


export function GetReceiveManageList(params) {
    return axios.post(`${BaseApiUrl}/ReceiveManage/GetReceiveManageList`, params);
}
 
export const getDepartmentList = params => {
    return axios.get(`${BaseApiUrl}/InventoryQuery/GetTWDeliveryInfoDepartment`, { params: params });
};

export function UpdatePutOnBoxInfo(params) {
    return axios.post(`${BaseApiUrl}/ReceiveManage/UpdatePutOnBoxInfo`, params);
}


export function ReceiveManageExport(params) {
    return axios.post(`${BaseApiUrl}/ReceiveManage/ReceiveManageExport`, params);
}

export function SynchroBaiYiSignForNo(params) {
    return axios.post(`${BaseApiUrl}/ReceiveManage/SynchroBaiYiSignForNo`, params);
}

//打印sku
export const printDeliveryInfoSku = params => {
    return axios.post(`${BaseApiUrl}/InventoryQuery/PrintDeliveryInfoSku`, params);
};

export function OverPutOn(params) {
    return axios.post(`${BaseApiUrl}/ReceiveManage/OverPutOn`, params);
}
